import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ContentProvider } from "@/content/ContentContext";
import { AuthProvider } from "@/auth/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import AIChatWidget from "@/components/AIChatWidget";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Pricing from "@/pages/Pricing";
import WhyUs from "@/pages/WhyUs";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#07090E] text-slate-100">
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  {/* Domain aliases — forward each product domain to its product page */}
                  <Route path="/workaholic" element={<Navigate to="/products/hr" replace />} />
                  <Route path="/workaholicgo" element={<Navigate to="/products/hr" replace />} />
                  <Route path="/kopera" element={<Navigate to="/products/coop" replace />} />
                  <Route path="/travelhubdesk" element={<Navigate to="/products/travel" replace />} />
                  <Route path="/storehive" element={<Navigate to="/products/store" replace />} />
                  <Route path="/adsboster" element={<Navigate to="/products/ads-booster" replace />} />
                  <Route path="/wasapme" element={<Navigate to="/products/wasap" replace />} />
                  <Route path="/tenanc" element={<Navigate to="/products/real-estate" replace />} />
                  <Route path="/buildingsociety" element={<Navigate to="/products/building-operations" replace />} />
                  <Route path="/yesgostream" element={<Navigate to="/products/stream" replace />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/industries/:slug" element={<IndustryDetail />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/why-us" element={<WhyUs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Auth mode="login" />} />
                  <Route path="/signup" element={<Auth mode="signup" />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <AIChatWidget />
              <Toaster position="top-center" richColors theme="dark" />
            </BrowserRouter>
          </AuthProvider>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
